export const order_zhCN = {
  'order.order.n01.lbl01': `按订单编号`,
  'order.order.n01.lbl02': `订单编号`,
  'order.order.n01.lbl03': `按会员`,
  'order.order.n01.lbl04': `会员编号`,
  'order.order.n01.lbl05': `会员手机号`,
  'order.order.n01.lbl06': `按订单属性`,
  'order.order.n01.rdo07': `订单类型`,
  'order.order.n01.rdo08': `订单来源`,
  'order.order.n01.rdo09': `订单开始日期`,
  'order.order.n01.rdo10': `订单结束日期`,
  'order.order.n01.chb11': `门店`,
  'order.order.n01.btn12': `重置`,
  'order.order.n01.btn13': `搜索`,
  'order.order.c01.lbl01': `订单编号`,
  'order.order.c01.lbl02': `会员编号`,
  'order.order.c01.lbl03': `订单类型`,
  'order.order.c01.lbl04': `订单金额`,
  'order.order.c01.lbl05': `订单来源`,
  'order.order.c01.lbl06': `门店名称`,
  'order.order.c01.lbl07': `订单时间`,
  'order.order.c01.lbl08': `筛选结果总正单数 `,
  'order.order.c01.lbl09': `总退单数 `,
  'order.order.c01.lbl10': `累计销售额 `,
  'order.order.c01.lbl11': `正单`,
  'order.order.c01.lbl12': `退单`,
  'order.order.c01.lbl13': `小程序`,
  'order.order.c01.lbl14': `官网`,
  'order.order.c01.lbl15': `查询`,
  'order.order.c01.lbl16': `京东`,
  'order.order.c01.lbl17': `天猫`,
  'order.order.c01.lbl18': `唯品会`,
  'order.order.c01.lbl19': `考拉`,
  'order.order.c01.lbl20': `抖音`,
  'order.order.c01.lbl21': `系统`,
  'order.order.detail.n01.lbl01': `会员详情`,
  'order.order.detail.n01.lbl02': `会员编号`,
  'order.order.detail.n01.lbl03': `会员卡号`,
  'order.order.detail.n01.lbl04': `会员卡等级`,
  'order.order.detail.n01.lbl05': `手机号`,
  'order.order.detail.n01.lbl06': `会员姓名`,
  'order.order.detail.n01.lbl07': `性别`,
  'order.order.detail.n01.lbl08': `会员生日`,
  'order.order.detail.n01.lbl09': `注册渠道`,
  'order.order.detail.n01.lbl10': `收件人`,
  'order.order.detail.n01.lbl11': `收件人手机号`,
  'order.order.detail.n01.lbl12': `收件人地址`,
  'order.order.detail.n01.lbl13': `零售类型`,
  'order.order.detail.n02.lbl01': `订单信息`,
  'order.order.detail.n02.lbl02': `订单编号`,
  'order.order.detail.n02.lbl03': `交易门店`,
  'order.order.detail.n02.lbl04': `交易门店名称`,
  'order.order.detail.n02.lbl05': `所属分公司`,
  'order.order.detail.n02.lbl06': `订单类型`,
  'order.order.detail.n02.lbl07': `订单来源`,
  'order.order.detail.n02.lbl08': `支付方式`,
  'order.order.detail.n02.lbl09': `下单时间`,
  'order.order.detail.n02.lbl10': `订单金额`,
  'order.order.detail.n02.lbl11': `实付金额`,
  'order.order.detail.n02.lbl12': `订单状态`,
  'order.order.detail.n02.lbl13': `收件人`,
  'order.order.detail.n02.lbl14': `收件人手机号`,
  'order.order.detail.n02.lbl15': `收件人地址`,

  'order.order.detail.c01.lbl01': `订单商品明细`,
  'order.order.detail.c01.lbl02': `商品SKU`,
  'order.order.detail.c01.lbl03': `商品名称`,
  'order.order.detail.c01.lbl04': `商品数量`,
  'order.order.detail.c01.lbl05': `商品单价`,
  'order.order.detail.c01.lbl06': `应付金额`,
  'order.order.detail.c01.lbl07': `实付金额`,
  'order.order.detail.c01.lbl08': `折扣金额`,
  'order.order.detail.c01.lbl09': `优惠券使用明细`,
  'order.order.detail.c01.lbl10': `卡券Code`,
  'order.order.detail.c01.lbl11': `类型`,
  'order.order.detail.c01.lbl12': `优惠券面额`,
  'order.order.detail.c01.lbl13': `订单获取积分`,
  'order.order.detail.c01.lbl14': `获得积分`,
  'order.order.detail.c01.lbl15': `备注`,
  'order.order.detail.c01.lbl16': `成交金额`,
};
export const order_enUS = {
  'order.order.n01.lbl01': `BY ORDER ID`,
  'order.order.n01.lbl02': `ORDER ID`,
  'order.order.n01.lbl03': `BY MEMBER`,
  'order.order.n01.lbl04': `MEMBER ID`,
  'order.order.n01.lbl05': `MEMBER MP NUMBER`,
  'order.order.n01.lbl06': `BY ORDER TYPE`,
  'order.order.n01.rdo07': `ORDER TYPE`,
  'order.order.n01.rdo08': `ORDER SOURCE`,
  'order.order.n01.rdo09': `FROM`,
  'order.order.n01.rdo10': `END`,
  'order.order.n01.chb11': `STORE`,
  'order.order.n01.btn12': `RESET`,
  'order.order.n01.btn13': `SEARCH`,
  'order.order.c01.lbl01': `ORDER ID`,
  'order.order.c01.lbl02': `MEMBER ID`,
  'order.order.c01.lbl03': `ORDER TYPE`,
  'order.order.c01.lbl04': `ORDER `,
  'order.order.c01.lbl05': `ORDER SOURCE`,
  'order.order.c01.lbl06': `STORE NAME`,
  'order.order.c01.lbl07': `ORDER TIME`,
  'order.order.c01.lbl08': `TOTAL POSITIVE NUMBER OF SCREENING RESULTS`,
  'order.order.c01.lbl09': `TOTAL RETURN A SINGULAR`,
  'order.order.c01.lbl10': `CUMULATIVE SALES`,
  'order.order.c01.lbl11': `IS SINGLE`, //正单
  'order.order.c01.lbl12': `RETURNS A SINGLE`, //退货单
  'order.order.c01.lbl13': `SMALL PROGRAM`, //小程序
  'order.order.c01.lbl14': `WEBSITE`, //官网
  'order.order.c01.lbl15': `SEARCH`, //查询
  'order.order.c01.lbl16': `JD`,
  'order.order.c01.lbl17': `TMALL`,
  'order.order.c01.lbl18': `VIPSHOP`,
  'order.order.c01.lbl19': `KAOLA`,
  'order.order.c01.lbl20': `Tik Tok`,
  'order.order.c01.lbl21': `SYSTEM`,
  'order.order.detail.n01.lbl01': `MEMBER DETAIL`,
  'order.order.detail.n01.lbl02': `MEMBER ID`,
  'order.order.detail.n01.lbl03': `MEMBER CARD ID`,
  'order.order.detail.n01.lbl04': `MEMBER RANK`,
  'order.order.detail.n01.lbl05': `MP NUMBER`,
  'order.order.detail.n01.lbl06': `MEMBER NAME`,
  'order.order.detail.n01.lbl07': `GENDER`,
  'order.order.detail.n01.lbl08': `MEMBER BIRTHDAY`,
  'order.order.detail.n01.lbl09': `SOURCE OF REGISTRATION`,
  'order.order.detail.n01.lbl10': `RECEIVER`, //收件人
  'order.order.detail.n01.lbl11': `RECEIVER MP NUMBER`, //收件人手机号
  'order.order.detail.n01.lbl12': `RECEIVER ADDRESS`, //收件人地址
  'order.order.detail.n01.lbl13': `SALE TYPE`, //零售类型
  'order.order.detail.n02.lbl01': `ORDER INFORMATION`,
  'order.order.detail.n02.lbl02': `ORDER ID`,
  'order.order.detail.n02.lbl03': `STORE`,
  'order.order.detail.n02.lbl04': `STORE NAME`,
  'order.order.detail.n02.lbl05': `SUBSIDIARY`,
  'order.order.detail.n02.lbl06': `ORDER TYPE`,
  'order.order.detail.n02.lbl07': `ORDER SOURCE`,
  'order.order.detail.n02.lbl08': `PAYMENT METHOD`,
  'order.order.detail.n02.lbl09': `ORDER TIME`,
  'order.order.detail.n02.lbl10': `ORDER AMOUNT`,
  'order.order.detail.n02.lbl11': `ACTUALLY PAID`,
  'order.order.detail.n02.lbl12': `ORDER STATUS`,
  // 'order.order.detail.n02.lbl13': `ORDER STATUS`,
  // 'order.order.detail.n02.lbl14': `ORDER STATUS`,
  // 'order.order.detail.n02.lbl15': `ORDER STATUS`,
  'order.order.detail.c01.lbl01': `ORDER ITEM DETAILS`,
  'order.order.detail.c01.lbl02': `ITEM SKU`,
  'order.order.detail.c01.lbl03': `ITEM NAME`,
  'order.order.detail.c01.lbl04': `ITEM QUANTITY`,
  'order.order.detail.c01.lbl05': `UNIT PRICE`,
  'order.order.detail.c01.lbl06': `ORDER AMOUNT`,
  'order.order.detail.c01.lbl07': `ACTUALLY PAID`,
  'order.order.detail.c01.lbl08': `DISCOUNT AMOUNT`,
  'order.order.detail.c01.lbl09': `VOUCHER DETAILS`,
  'order.order.detail.c01.lbl10': `VOUCHER CODE`,
  'order.order.detail.c01.lbl11': `TYPE`,
  'order.order.detail.c01.lbl12': `VOUCHER VALUE`,
  'order.order.detail.c01.lbl13': `POINTS GAINED IN ORDER`,
  'order.order.detail.c01.lbl14': `POINTS GAINED`,
  'order.order.detail.c01.lbl15': `REMARK`,
  'order.order.detail.c01.lbl16': `TRANSACTION AMOUNT`, //成交金额
};
